import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { ElMessage } from 'element-plus'
import Store from "../store/index";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect:'/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/login1',
    name: 'login1',
    component: () => import('../views/Login/index1.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/Error/index.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/index.vue'),
    redirect:'/topicManagement',
    children:[{
      path: '/topicManagement',
      name: '题目管理',
      component: () => import( /* webpackChunkName: "about" */ '../views/TopicManagement/index.vue')
  },
  // {
  //     path: '/tagsManagement',
  //     name: '标签管理',
  //     component: () => import( /* webpackChunkName: "about" */ '../views/Tags/index.vue')
  // },
  {
    path: '/assessmentManagement',
    name: '考核管理',
    component: () => import( /* webpackChunkName: "about" */ '../views/AssessmentManagement/index.vue')
  },{
    path: '/assessmentManagementDetail',
    name: '考核详情',
    component: () => import( /* webpackChunkName: "about" */ '../views/AssessmentManagement/detail.vue')
  },{
    path: '/assessmentManagementLog',
    name: '考核记录',
    component: () => import( /* webpackChunkName: "about" */ '../views/AssessmentManagement/log.vue')
  },
  {
    path: '/assessmentGrade',
    name: '答题详情',
    component: () => import( /* webpackChunkName: "about" */ '../views/AssessmentManagement/grade.vue')
  },
  {
    path: '/assessmentInformation',
    name: '简答题评分',
    component: () => import( /* webpackChunkName: "about" */ '../views/AssessmentManagement/information.vue')
  },
  {
    path: '/newChart',
    name: '报表生成',
    component: () => import( /* webpackChunkName: "about" */ '../views/ChartManagement/newChart.vue')
  },
  {
    path: '/chartManagement',
    name: '报表列表',
    component: () => import( /* webpackChunkName: "about" */ '../views/ChartManagement/index.vue')
  },
  {
    path: '/chartDetail',
    name: '报表详情',
    component: () => import( /* webpackChunkName: "about" */ '../views/ChartManagement/chartDetail.vue')
  },
  {
    path: '/userManagement',
    name: '人员管理',
    component: () => import( /* webpackChunkName: "about" */ '../views/User/index.vue')
  },{
    path: '/permissionManagement',
    name: '权限配置',
    component: () => import( /* webpackChunkName: "about" */ '../views/PermissionManagement/index.vue')
  },{
    path: '/groupManagement',
    name: '分组管理',
    component: () => import( /* webpackChunkName: "about" */ '../views/PermissionManagement/groupManagement.vue')
  },
  {
    path: '/statistics',
    name: '统计',
    component: () => import( /* webpackChunkName: "about" */ '../views/Statistics/index.vue')
  }]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
const roleList = Store.getters.userData || []
router.beforeEach((to, from, next) => {
  const token = Store.getters.token
  if(to.path === '/login'||to.path === '/login1'){
    next()
  }else if (token){
    next()
    // switch(to.path){
    //   case '/home': 
    //     next()
    //   break;
    //   case '/topicManagement': 
    //   roleList.forEach(element => {
    //     if(element==='Question'){
    //       next()
    //     }
    //   })
    //   break;
    //   case '/assessmentManagement': 
    //   roleList.forEach(element => {
    //     if(element==='Exam'){
    //       next()
    //     }
    //   })
    //   break;
    //   case '/assessmentManagementDetail': 
    //   roleList.forEach(element => {
    //     if(element==='Exam'){
    //       next()
    //     }
    //   })
    //   break;
    //   case '/assessmentManagementLog': 
    //   roleList.forEach(element => {
    //     if(element==='Exam'){
    //       next()
    //     }
    //   })
    //   break;
    //   case '/userManagement': 
    //   roleList.forEach(element => {
    //     if(element==='User'){
    //       next()
    //     }
    //   })
    //   break;
    //   case '/permissionManagement': 
    //   roleList.forEach(element => {
    //     if(element==='Permission'){
    //       next()
    //     }
    //   })
    //   break;
    //   default:
    //     next('/404')
    //     break
    // }
  }else{
    // 是否为SSO
    if(to.path.indexOf('/access_token=')>=0){
      setTimeout(()=>{
        next('/login')
      },1000)
    }else{
      ElMessage.error('please login!')
      setTimeout(()=>{
        next('/login')
      },1000)
    }
  }
})

export default router
